// removed by extract-text-webpack-plugin
module.exports = {"leftNav":"App__leftNav___2Vf-w","contentWithLeftNav":"App__contentWithLeftNav___3NdLt","chapter":"App__chapter___3OYFY","chapterHeader":"App__chapterHeader___2ez7p","chapterTitle":"App__chapterTitle___3zoBH","chapterSubtitle":"App__chapterSubtitle___3AL5f","nonIdeal":"App__nonIdeal___2LjAN","noDataMessage":"App__noDataMessage___3XuaQ","header":"App__header___6qXLw","notifications":"App__notifications___1yBEG","body":"App__body___2gc65"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/App.css
// module id = 1534
// module chunks = 0